export const String = {
    toTitleCase: (s) => 
        s.toLowerCase()
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
};